import { acceptHMRUpdate, defineStore } from 'pinia'
import { useMenuNavApi, useMenuAllApi } from '@/api/menu'
import { generateRoutes, addAccountsWithRouter } from '@/router'
import { RouteRecordRaw } from 'vue-router'
import { developmentRouter, userRouter, userRouterSub, userRouterCompany, userRouterAccounts, developmentRouterClient } from '@/config/menu'
import { setRouterMenuList } from '@/utils/tool'
import { Storage } from '@/utils/storage'
import PageAccounts from '@/views/PageAccounts/Index.vue'

const isDevelopment = import.meta.env.MODE == 'development';

export const routerStore = defineStore('routerStore', {
	state: () => ({
		menuList: [],
		menuRoutes: [] as RouteRecordRaw[],
		searchMenu: [] as RouteRecordRaw[],
		routes: [] as RouteRecordRaw[]
	}),
	actions: {
		async getMenuRoutes() {
			// const allData: any = await useMenuAllApi()
			const allData: any = await useMenuNavApi()
			this.menuList = allData.data
			const dataThen: any = setRouterMenuList(allData.data)
			// if(Storage.getItem('user_system') == 2 && data.length == 0){
			// 	if (Storage.getItem('login_info')?.user?.account_type == 'sub') {
			// 		dataThen.push(...userRouterSub)
			// 	} else if (Storage.getItem('login_info')?.user?.account_type == 'company') {
			// 		dataThen.push(...userRouterCompany)
			// 	} else {
			// 		dataThen.push(...userRouter)
			// 	}
			// }
			if(isDevelopment){
				dataThen.push(...developmentRouter)
			}
			// if((isDevelopment || Storage.getItem('login_info')?.user_info?.username == '13735725151') && Storage.getItem('user_system') == 1){
			// 	dataThen.push(...developmentRouter)
			// }
			// 替换图标
			dataThen.forEach((item:any) => {
				const fitem = allData.data?.find((i:any) => i.route == item.url)
				if (fitem) {
					item.icon = fitem.icon
				}
			});
            // console.log('dataThen', dataThen);
			const routes = generateRoutes(dataThen)
			this.menuRoutes.push(...routes)

			return this.menuRoutes
		},
		setSearchMenu(routers: RouteRecordRaw[]) {
			this.searchMenu = routers
		},
		setRoutes(routers: RouteRecordRaw[]) {
			this.routes = routers
		},
		addRouterAccounts() {
			addAccountsWithRouter()
			const routes: any = generateRoutes(userRouterAccounts)
			this.menuRoutes.splice(2, 0, routes[0])
		}
	}
})
// 确保传递正确的 store 声明，本例中为 `useAuth`
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(routerStore, import.meta.hot))
}
